import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'  // 设置浏览器标签名称

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/usrLogin', '/auth-redirect', '/overseas', '/globalLogin'] // no redirect whitelist
// const getQueryString = (name, search) => {
//  search = search || window.location.search.substr(1) || window.location.hash.split("?")[1];
//  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
//  if (search) {
//     const r = search.match(reg);
//     if (r != null) return unescape(r[2]); return null;
//   } else {
//     return
//   }
//   }

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title 设置浏览器标签名称
  if (store.getters.name === 'overseas') {
    document.title = 'Repair & Maintenance Information Platform'
  } else {
    document.title = getPageTitle(to.meta.title)
  }

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else if (to.path === '/globalLogin') {
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // debugger
          const { moudles } = await store.dispatch('user/getInfo')
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', moudles)

          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (ex) {
          // debugger
          const r = localStorage.getItem("roles");
          if (r === "overseas") {
            store.dispatch("user/overseas")
              .then(res => {
                const { loginSysUserVo } = res;
                localStorage.setItem('userId', loginSysUserVo.id)
                next("/overseas")
              })
            return
          }

          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(ex || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({ path: '/login' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

